import Cookies from 'js-cookie';

const ENV = process.env;

let SSOWeb = require('@mtfe/sso-web').default;
// const isProduction = process.env.NODE_ENV === 'production'
const isProduction = window.location.host === 'moa.sankuai.com';

export const ssoWeb = new SSOWeb({
  clientId: isProduction ? ENV.VUE_APP_CLIENT_ID_PROD : ENV.VUE_APP_CLIENT_ID, // 这里要写当前项目的 clientId  必填
  // test or product
  accessEnv: isProduction ? 'product' : 'test',
  callbackUrl: '/#/callback',
  excludedUriList: '/#/',
});
// ssoWeb.init();
const sso = {
  redirectLogin() {
    ssoWeb.login();
  },
  redirectLoginNew() {
    // 登出之后再登录，跳转到首页
    window.location.href = ssoWeb.getLoginUrl();
  },
  logout() {
    let token = this.getSsoid();
    ssoWeb.logout(token).then(() => {
      this.removeSsoid();
      this.setCurrentURL();
      this.redirectLoginNew();
    });
  },
  removeSsoid() {
    Cookies.remove('ssoid');
  },
  setSsoid(ssoid) {
    Cookies.set('ssoid', ssoid, { expires: 7 });
  },
  getSsoid() {
    return Cookies.get('ssoid');
  },
  setCurrentURL() {
    const currentURL = window.location.href;
    if (!currentURL.includes('/callback')) {
      Cookies.set('currentURL', currentURL);
    }
  },
  getCurrentURL() {
    return Cookies.get('currentURL') || '/';
  },
};

export default sso;
